module.exports = __webpack_public_path__ + "img/passport_zh.c1768517.png";